import React, { useContext } from 'react';
import { useParams } from 'next/navigation';
import { Popover } from '@headlessui/react';
import Image from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import AccountDropdown from 'components/commercetools-ui/organisms/account/account-atoms/account-dropdown';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import { UtilityLink } from '../../types';

const AccountButton = ({
  utilityLink,
  className,
  imageStyle,
}: {
  utilityLink: UtilityLink;
  className?: string;
  imageStyle?: string;
}) => {
  const { account, loggedIn } = useContext(AccountContext);
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { locale } = useParams();

  const localeKey = locale.replace(/-/g, '_');

  const title = account
    ? formatAccountMessage({ id: 'account', defaultMessage: 'Account' })
    : formatAccountMessage({ id: 'sign.in', defaultMessage: 'Login' });

  return (
    <>
      <Link link={account ? '/account' : '/login'} title={title} className="hidden sm:flex lg:hidden">
        <div className={className}>
          <Image
            className={`${imageStyle} lg:hidden`}
            src={utilityLink.icon?.media?.file}
            alt={
              utilityLink.icon?.media?.alt ??
              (utilityLink.icon?.title?.[localeKey as keyof typeof localeKey] as string) ??
              ''
            }
            title={(utilityLink.icon?.title?.[localeKey as keyof typeof localeKey] as string) ?? ''}
          />
        </div>
      </Link>
      <Popover as="div" className="relative hidden lg:flex">
        {() => (
          <>
            <Popover.Button title={title} className={`${className} focus-visible:!outline-none`}>
              <Image
                className={imageStyle}
                src={utilityLink.icon?.media?.file}
                alt={
                  utilityLink.icon?.media?.alt ??
                  (utilityLink.icon?.title?.[localeKey as keyof typeof localeKey] as string) ??
                  ''
                }
                title={(utilityLink.icon?.title?.[localeKey as keyof typeof localeKey] as string) ?? ''}
              />
            </Popover.Button>
            <Popover.Overlay className="fixed inset-0 z-[310] bg-secondary-black opacity-30" />
            <Popover.Panel className="absolute right-0 top-50 z-[351] animate-[appearDropdown_0.15s_ease-in-out] rounded-sm bg-white shadow-400">
              <div className="absolute -top-20 right-0 z-10 w-31 overflow-hidden">
                <div className="size-21 origin-bottom-left rotate-45 bg-white" />
              </div>
              <AccountDropdown loggedIn={loggedIn} />
            </Popover.Panel>
          </>
        )}
      </Popover>
    </>
  );
};

export default AccountButton;
